import React from "react"
import Container from "./IconContainer"


const CostIcon = ({ ...props }) => (
  <Container {...props}>
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="190701"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="2_NYT-Dashboard-D"
          transform="translate(-106.000000, -4245.000000)"
        >
          <g id="Group-9" transform="translate(107.000000, 4246.000000)">
            <path
              d="M7.66455078,8.22338867 C7.66455078,7.96980667 7.59419829,7.76802647 7.45349121,7.61804199 C7.31278413,7.46805752 7.07389491,7.32967186 6.73681641,7.20288086 C6.3997379,7.07608986 6.1090507,6.95007387 5.86474609,6.8248291 C5.62044149,6.69958433 5.41093024,6.55578694 5.23620605,6.39343262 C5.06148187,6.23107829 4.92541553,6.04012154 4.82800293,5.82055664 C4.73059033,5.60099174 4.68188477,5.3396825 4.68188477,5.03662109 C4.68188477,4.51399478 4.84887528,4.08569503 5.18286133,3.75170898 C5.51684737,3.41772294 5.96060921,3.22290067 6.51416016,3.16723633 L6.51416016,2.17456055 L7.25634766,2.17456055 L7.25634766,3.18115234 C7.80371367,3.25846393 8.23201343,3.48652968 8.54125977,3.86535645 C8.8505061,4.24418321 9.00512695,4.73510441 9.00512695,5.33813477 L7.66455078,5.33813477 C7.66455078,4.96703916 7.58801346,4.68949474 7.43493652,4.50549316 C7.28185959,4.32149159 7.07698696,4.22949219 6.8203125,4.22949219 C6.5667305,4.22949219 6.37036202,4.30139088 6.23120117,4.44519043 C6.09204032,4.58898998 6.02246094,4.78767777 6.02246094,5.04125977 C6.02246094,5.27628698 6.09049411,5.46492442 6.2265625,5.60717773 C6.36263089,5.74943105 6.61543598,5.89477465 6.98498535,6.04321289 C7.35453473,6.19165113 7.65836469,6.331583 7.89648438,6.4630127 C8.13460406,6.59444239 8.33561116,6.7428784 8.49951172,6.9083252 C8.66341228,7.07377199 8.78865517,7.26240942 8.87524414,7.47424316 C8.96183312,7.68607691 9.00512695,7.93269716 9.00512695,8.21411133 C9.00512695,8.7398301 8.84122885,9.16658365 8.51342773,9.49438477 C8.18562662,9.82218588 7.73413374,10.0154619 7.15893555,10.0742188 L7.15893555,10.9973145 L6.42138672,10.9973145 L6.42138672,10.0788574 C5.78743173,10.0108232 5.29651053,9.78584989 4.9486084,9.40393066 C4.60070627,9.02201144 4.42675781,8.51408195 4.42675781,7.88012695 L5.76733398,7.88012695 C5.76733398,8.2481301 5.85469476,8.53031315 6.02941895,8.72668457 C6.20414313,8.92305599 6.45540201,9.02124023 6.78320312,9.02124023 C7.0553399,9.02124023 7.27026288,8.94934154 7.42797852,8.80554199 C7.58569415,8.66174245 7.66455078,8.46769328 7.66455078,8.22338867 Z"
              id="$"
              fill="#505050"
              fillRule="nonzero"
            />
            <circle
              id="Oval"
              stroke="#505050"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              cx="7"
              cy="7"
              r="7"
            />
          </g>
        </g>
      </g>
    </svg>
  </Container>
)

export default CostIcon



// WEBPACK FOOTER //
// ./assets/common/components/icons/CostIcon.js